import React from 'react';
import { useTranslation } from '../Context/TranslationContext';
import { MapPinIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';

const DistrictTrainingCenters = () => {
  const { isTamil } = useTranslation();

  const translations = {
    en: {
      title: "CAMPING CENTRES",
      subtitle: "DISTRICT TRAINING CENTRES- TAMIL NADU",
      columnHeaders: {
        sno: "S. No",
        district: "District",
        center: "Camp Centre & Place"
      },
      stats: {
        totalCenters: "Total Centers",
        totalDistricts: "Districts Covered"
      },
      centers: [
        { id: 1, district: "Dharmapuri", center: "Rajendran Park", place: "Hoganekal" },
        { id: 2, district: "Salem", center: "Sankar Park", place: "Seshanchavadi" },
        { id: 3, district: "Namakkal", center: "District Training Centre", place: "Collector's Office" },
        { id: 4, district: "Musiri", center: "Nehru Park", place: "Musiri" },
        { id: 5, district: "Dindugal", center: "District Training Centre", place: "" },
        { id: 6, district: "Cheranmadevi", center: "Sundarabavanam", place: "Papamasam" },
        { id: 7, district: "Perambalur", center: "District Training Centre", place: "" },
        { id: 8, district: "Viruthachalam", center: "NVR Park", place: "Irathukudi" },
        { id: 9, district: "Villupuram", center: "District Training Centre", place: "Valavanur" },
        { id: 10, district: "Thiruvannamalai", center: "District Training Centre", place: "" },
        { id: 11, district: "Vellore", center: "District Training Centre", place: "" },
        { id: 12, district: "Madurai", center: "District Training Centre", place: "" }
      ]
    },
    ta: {
      title: "முகாம் மையங்கள்",
      subtitle: "மாவட்ட பயிற்சி மையங்கள் - தமிழ்நாடு",
      columnHeaders: {
        sno: "வ.எண்",
        district: "மாவட்டம்",
        center: "முகாம் மையம் & இடம்"
      },
      stats: {
        totalCenters: "மொத்த மையங்கள்",
        totalDistricts: "மாவட்டங்கள்"
      },
      centers: [
        { id: 1, district: "தர்மபுரி", center: "ராஜேந்திரன் பூங்கா", place: "ஓகேனக்கல்" },
        { id: 2, district: "சேலம்", center: "சங்கர் பூங்கா", place: "சேஷாச்சாவடி" },
        { id: 3, district: "நாமக்கல்", center: "மாவட்ட பயிற்சி மையம்", place: "மாவட்ட ஆட்சியர் அலுவலகம்" },
        { id: 4, district: "முசிறி", center: "நேரு பூங்கா", place: "முசிறி" },
        { id: 5, district: "திண்டுக்கல்", center: "மாவட்ட பயிற்சி மையம்", place: "" },
        { id: 6, district: "செரன்மாதேவி", center: "சுந்தரபவனம்", place: "பாபநாசம்" },
        { id: 7, district: "பெரம்பலூர்", center: "மாவட்ட பயிற்சி மையம்", place: "" },
        { id: 8, district: "விருத்தாசலம்", center: "என்.வி.ஆர் பூங்கா", place: "இரத்துக்குடி" },
        { id: 9, district: "விழுப்புரம்", center: "மாவட்ட பயிற்சி மையம்", place: "வலவனூர்" },
        { id: 10, district: "திருவண்ணாமலை", center: "மாவட்ட பயிற்சி மையம்", place: "" },
        { id: 11, district: "வேலூர்", center: "மாவட்ட பயிற்சி மையம்", place: "" },
        { id: 12, district: "மதுரை", center: "மாவட்ட பயிற்சி மையம்", place: "" }
      ]
    }
  };

  const t = translations[isTamil ? 'ta' : 'en'];

  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12 px-4 sm:px-6 lg:px-8 mt-16">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className={`text-3xl font-bold text-gray-900 ${isTamil ? 'text-2xl' : ''}`}>
            {t.title}
          </h1>
          <h2 className={`text-2xl font-semibold text-gray-800 mt-2 ${isTamil ? 'text-xl' : ''}`}>
            {t.subtitle}
          </h2>
        </div>

        {/* Stats Cards */}
        <div className="mb-12 grid grid-cols-1 gap-5 sm:grid-cols-2 max-w-2xl mx-auto">
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-blue-500 rounded-md p-3">
                  <BuildingOfficeIcon className="h-6 w-6 text-white" />
                </div>
                <div className="ml-5">
                  <dl>
                    <dt className={`text-sm font-medium text-gray-500 truncate ${isTamil ? 'text-xs' : ''}`}>
                      {t.stats.totalCenters}
                    </dt>
                    <dd className="mt-1 text-3xl font-semibold text-gray-900">12</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-green-500 rounded-md p-3">
                  <MapPinIcon className="h-6 w-6 text-white" />
                </div>
                <div className="ml-5">
                  <dl>
                    <dt className={`text-sm font-medium text-gray-500 truncate ${isTamil ? 'text-xs' : ''}`}>
                      {t.stats.totalDistricts}
                    </dt>
                    <dd className="mt-1 text-3xl font-semibold text-gray-900">12</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Centers Table */}
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-800">
                <tr>
                  <th scope="col" className="px-6 py-4 text-left text-sm font-semibold text-white">
                    {t.columnHeaders.sno}
                  </th>
                  <th scope="col" className="px-6 py-4 text-left text-sm font-semibold text-white">
                    {t.columnHeaders.district}
                  </th>
                  <th scope="col" className="px-6 py-4 text-left text-sm font-semibold text-white">
                    {t.columnHeaders.center}
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {t.centers.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {item.id}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      {item.district}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      {item.center && `"${item.center}"`} {item.place && `- ${item.place}`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistrictTrainingCenters;